import { DateTime } from 'luxon'

export type InsightPeriod = '1m' | '3m' | '6m' | '1y'

export const INSIGHT_PERIOD_OPTIONS: { value: InsightPeriod; label: string }[] = [
  { value: '1m', label: '1ヶ月' },
  { value: '3m', label: '3ヶ月' },
  { value: '6m', label: '6ヶ月' },
  { value: '1y', label: '1年' },
]

export const DEFAULT_INSIGHT_PERIOD: InsightPeriod = '6m'

const PERIOD_DAYS_BEFORE_YESTERDAY: Record<InsightPeriod, number> = {
  '1m': 29,
  '3m': 89,
  '6m': 179,
  '1y': 364,
}

/** TDD: to = 昨日、from = 昨日から遡った日数 */
export const getInsightDateRange = (period: InsightPeriod): { from: DateTime; to: DateTime } => {
  const today = DateTime.now().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
  const to = today.minus({ day: 1 })
  const from = to.minus({ day: PERIOD_DAYS_BEFORE_YESTERDAY[period] })
  return { from, to }
}

export const formatInsightPeriodLabel = (from: DateTime, to: DateTime): string => {
  return `${from.toFormat('yyyy/M/d')}~${to.toFormat('yyyy/M/d')}の合計`
}
